import { render, staticRenderFns } from "./checklist-image.vue?vue&type=template&id=36c4ac4a&scoped=true&"
import script from "./checklist-image.vue?vue&type=script&lang=js&"
export * from "./checklist-image.vue?vue&type=script&lang=js&"
import style0 from "./checklist-image.vue?vue&type=style&index=0&id=36c4ac4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c4ac4a",
  null
  
)

export default component.exports